<ion-list *ngIf="(items$ | async)!.length >= 1" lines="full">
	<ion-item *ngFor="let item of items$ | async" (click)="onClicked(item)">
		<calao-customer-selector-popover-item [item]="item"></calao-customer-selector-popover-item>
	</ion-item>
</ion-list>